<template>
  <div class="panel">
    <div class="panel-heading">
      <div class="pure-g">
        <div class="pure-u-1 pure-u-md-1-2">
          Calculadora Solartex
        </div>
        <div class="pure-u-1 pure-u-md-1-2">
          <select v-model="defaultOption" @change="addArtefactoFromTemplate" style="float: right;">
            <option value="" selected disabled>Agrega desde una plantilla</option>
            <option
              v-for="(data, index) in filterOptions"
              :value="index"
              :key="index"
            >
              {{ data.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="item-block">
      <div class="item-header">
        Agregar Artefacto
      </div>
      <div class="item-body">
        <fieldset>
          <div class="pure-g">
            <div class="pure-u-1 pure-u-md-1-4">
              <label for="name">Artefacto</label>
              <input type="text" id="name" v-model="artefacto.name" />
            </div>
            <div class="pure-u-1 pure-u-md-1-4">
              <label for="cantidad">Cantidad</label>
              <input type="number" id="cantidad" v-model="artefacto.cantidad" />
            </div>
            <div class="pure-u-1 pure-u-md-1-4">
              <label for="consumo">Consumo ( Watts )</label>
              <input type="number" id="consumo" v-model="artefacto.consumo" />
            </div>
            <div class="pure-u-1 pure-u-md-1-4">
              <label for="horas">Horas del día</label>
              <input type="number" id="horas" v-model="artefacto.horas" />
            </div>
          </div>
          <div style="text-align:center;">
            <a href="#" class="button" @click.prevent="addArtefacto">Agregar Artefacto</a>
          </div>
        </fieldset>
      </div>
      <div class="item-footer">
        <div class="pure-g">
          <div class="pure-u-1 pure-u-md-1-2">
            <div class="totales-footer">
              Total Consumo ( Wh ):
              <span class="item-total">
                {{ artefacto.cantidad * artefacto.consumo }}
              </span>
            </div>

          </div>
          <div class="pure-u-1 pure-u-md-1-2">
            <div class="totales-footer">
              Total Energía ( Watts ):
              <span class="item-total">
                {{ artefacto.cantidad * artefacto.consumo * artefacto.horas }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="pure-table pure-table-bordered" v-show="artefactos.length > 0">
      <thead>
        <tr>
          <th>Cantidad</th>
          <th>Consumo</th>
          <th>Horas</th>
          <th>Energía</th>
        </tr>
      </thead>
      <tbody
        v-for="data in artefactos"
        :key="data.id"
      >
        <tr>
          <td colspan="4" style="font-weight: bold; padding-top: 5px;">
            {{ data.name }}
            <button class="delete" @click="deleteArtefacto($event, data.id)">&times;</button>
          </td>
        </tr>
        <tr>
          <td>{{ data.cantidad }}</td>
          <td>{{ data.consumo }}</td>
          <td>{{ data.horas }}</td>
          <td>{{ data.cantidad * data.consumo * data.horas }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">Total Consumo ( Wh )</td>
          <td class="td-totals">{{ calcConsumoTotal }}</td>
        </tr>
        <tr>
          <td colspan="3">Total Energía ( Watts )</td>
          <td class="td-totals">{{ calcEnergiaTotal }}</td>
        </tr>
      </tfoot>
    </table>

    <br>
    <div class="cotizar">
      <a href="https://www.solartex.co/contacto/" class="button">Cotizar</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calculadora',
  data() {
    return {
      defaultOption: '',
      options: [
        {
          name: 'Nevera', cantidad: 1, consumo: 80, horas: 24,
        },
        {
          name: 'Microondas', cantidad: 1, consumo: 800, horas: 0.25,
        },
        {
          name: 'Horno', cantidad: 1, consumo: 1500, horas: 0.6,
        },
        {
          name: 'Arrocera', cantidad: 1, consumo: 700, horas: 0.4,
        },
        {
          name: 'Juguera', cantidad: 1, consumo: 150, horas: 0.1,
        },
        {
          name: 'Extractor', cantidad: 1, consumo: 150, horas: 0.3,
        },
        {
          name: 'Lavavajillas', cantidad: 1, consumo: 650, horas: 1,
        },
        {
          name: 'Hervidor', cantidad: 1, consumo: 850, horas: 0.2,
        },
        {
          name: 'Bombillos', cantidad: 1, consumo: 5, horas: 5,
        },
        {
          name: 'Tubo Fluor', cantidad: 1, consumo: 18, horas: 5,
        },
        {
          name: 'Sec. Cabello', cantidad: 1, consumo: 800, horas: 0.1,
        },
        {
          name: 'Lavadora', cantidad: 1, consumo: 700, horas: 1,
        },
        {
          name: 'Secadora', cantidad: 1, consumo: 2800, horas: 1,
        },
        {
          name: 'Centrifuga', cantidad: 1, consumo: 400, horas: 0.3,
        },
        {
          name: 'Tv Led', cantidad: 1, consumo: 40, horas: 4,
        },
        {
          name: 'Equipo Audio', cantidad: 1, consumo: 70, horas: 4,
        },
        {
          name: 'Computador', cantidad: 1, consumo: 200, horas: 4,
        },
        {
          name: 'Portatil', cantidad: 1, consumo: 70, horas: 4,
        },
        {
          name: 'Impresora', cantidad: 1, consumo: 30, horas: 0.1,
        },
        {
          name: 'Carg. Celular', cantidad: 1, consumo: 30, horas: 2,
        },
        {
          name: 'Calefacción', cantidad: 1, consumo: 1500, horas: 1,
        },
        {
          name: 'Aire Acond.', cantidad: 1, consumo: 1700, horas: 1,
        },
        {
          name: 'Motor Piscina', cantidad: 1, consumo: 750, horas: 3,
        },
        {
          name: 'Bomba Pozo', cantidad: 1, consumo: 750, horas: 3,
        },
      ],
      nextId: 1,
      artefacto: {
        name: '',
        cantidad: '',
        consumo: '',
        horas: '',
      },
      artefactos: [],
    };
  },
  computed: {
    filterOptions() {
      return this.options;
    },
    calcConsumoTotal() {
      let totalConsumo = 0;
      this.artefactos.forEach((elem) => {
        totalConsumo += (elem.cantidad * elem.consumo);
      });

      return totalConsumo;
    },
    calcEnergiaTotal() {
      let totalEnergia = 0;
      this.artefactos.forEach((elem) => {
        totalEnergia += (elem.cantidad * elem.consumo * elem.horas);
      });

      return totalEnergia;
    },
  },
  methods: {
    addArtefactoFromTemplate(event) {
      const index = event.target.value;
      this.artefacto = Object.assign({}, this.options[index]);
      this.defaultOption = '';
    },
    addArtefacto() {
      if (
        this.artefacto.name === ''
          || this.artefacto.cantidad === ''
          || this.artefacto.consumo === ''
          || this.artefacto.horas === ''
      ) {
        return false;
      }

      if (
        this.artefacto.cantidad <= 0
        || this.artefacto.consumo <= 0
        || this.artefacto.horas <= 0
      ) {
        return false;
      }

      this.artefactos.push({
        id: this.nextId,
        ...this.artefacto,
      });

      this.nextId += 1;
      this.artefacto = {
        name: '',
        cantidad: '',
        consumo: '',
        horas: '',
      };

      return true;
    },
    deleteArtefacto(event, id) {
      const index = this.artefactos.findIndex(elem => elem.id === id);
      this.artefactos.splice(index, 1);
    },
  },
};
</script>

<style scoped>
  .pure-table {
    width: 100%;
  }

  .pure-table thead tr th {
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  }

  .pure-table tfoot tr td {
    font-weight: bold;
    background-color: #2ea3f2;
    color: #fff;
  }

  .pure-table-bordered tbody > tr:last-child > td {
    border-bottom-width: 2px;
  }

  .td-totals {
    text-align: center;
    font-size: 1.2rem;
  }

  .panel {
    max-width: 700px;
    padding: 1.2rem;
    margin-left: auto;
    margin-right: auto;
  }

  .panel-heading {
    padding: 0.8rem;
    margin: 0;
    font-weight: bold;
    background-color: #f0f0f0;
    color: #000;
  }

  .item-block {
    border: 1px solid #2ea3f2;
    margin-bottom: 15px;
  }

  .item-block .item-header {
    font-weight: bold;
    padding: 0.5rem;
    background-color: #2ea3f2;
    color: #fff;
  }

  .item-block .item-body {
    padding: 0.8rem;
  }

  .item-block .item-body input {
    width: 90%;
    margin-bottom: 10px;
    padding: 5px;
    border: 1px solid #999;
  }

  .item-block .item-body label {
    font-weight: bold;
  }

  .item-block .item-footer {
    font-weight: bold;
    color: #2ea3f2;
  }

  .item-block .item-footer {
    font-weight: bold;
    padding: 0.5rem;
    background-color: #2ea3f2;
    color: #fff;
    font-size: 1.1em;
  }

  .item-block .item-footer .item-total {
    float: right;
    margin-right: 30px;
  }

  .item-block .item-footer .totales-footer {
    margin-bottom: 5px;
  }

  .button {
    border-width: 2px!important;
    border-radius: 11px;
    text-shadow: 0.07em 0.05em 0.1em rgba(0,0,0,0.4);
    box-shadow: 10px 6px 18px 0px rgba(0,0,0,0.3);
    transition: all 300ms ease 0ms;
    position: relative;
    text-decoration: none;
    padding: .3em 1em;
    border: 2px solid;
    color: #2ea3f2;
    cursor: pointer;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.7em!important;
    -moz-transition: all .2s;
  }

  .delete {
    /* -webkit-appearance: none; */
    background-color: rgba(250, 25, 25, 0.664);
    color: #eeeeee;
    border: none;
    border-radius: 290486px;
    cursor: pointer;
    float: right;
  }

  .cotizar {
    text-align: center;
  }
</style>
